exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact-details p {\n  margin-bottom: 0; }\n\n.message-padding {\n  padding: 15px;\n  font-weight: 500; }\n\n.map {\n  width: 100%;\n  height: 395px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/contact/contact.component.scss
// module id = 332
// module chunks = 1